// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__35ciH","label":"CategoryService_label__siDwu","location":"CategoryService_location__2V1QJ"};